import type { CityConfig } from "../city-template/types";

export const salisburyMdConfig: CityConfig = {
  city: "Salisbury",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "salisbury-md",
  route: "/cities/salisbury-md",
  title: "Emergency Passport Salisbury, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Salisbury, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Salisbury, Fruitland, Delmar, and Hebron residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Salisbury, MD",
  heroSubtitle: "Salisbury travelers — from the Eastern Shore campus to the coastal resort corridor to the Delaware border — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Wicomico County and the Eastern Shore.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Charming%20historic%20downtown%20Salisbury%20Maryland%20with%20brick%20storefront%20buildings%2C%20tree-lined%20Main%20Street%2C%20small-town%20Eastern%20Shore%20architecture%2C%20warm%20afternoon%20sunlight%2C%20Salisbury%20University%20campus%20area%20visible%20in%20the%20distance%2C%20clean%20and%20inviting%20downtown%20district%2C%20no%20visible%20text%20or%20people%2C%20warm%20earth%20tones%20and%20soft%20golden%20lighting%2C%20professional%20photography%20style&width=1800&height=700&seq=salisbury-md-hero-001&orientation=landscape",
  heroImageAlt: "Historic downtown Salisbury Maryland with charming brick storefront buildings and warm afternoon sunlight",
  geoPosition: "38.3607;-75.5994",
  geoPlacename: "Salisbury, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 2.5–3 hours from Salisbury via US-50 W and I-495 S",
  },
  nearbyCitiesZips: [
    { name: "Salisbury", zips: "21801, 21802, 21803, 21804" },
    { name: "Fruitland", zips: "21826" },
    { name: "Delmar", zips: "21875" },
    { name: "Hebron", zips: "21830" },
    { name: "Parsonsburg", zips: "21849" },
    { name: "Pittsville", zips: "21850" },
    { name: "Willards", zips: "21874" },
    { name: "Mardela Springs", zips: "21837" },
    { name: "Quantico", zips: "21856" },
    { name: "Eden", zips: "21822" },
    { name: "Powellville", zips: "21852" },
    { name: "Whaleyville", zips: "21872" },
    { name: "Allen", zips: "21810" },
    { name: "Nanticoke", zips: "21840" },
    { name: "Bivalve", zips: "21814" },
    { name: "Ocean City", zips: "21842, 21843" },
    { name: "Berlin", zips: "21811" },
    { name: "Ocean Pines", zips: "21811" },
    { name: "Snow Hill", zips: "21863" },
    { name: "Pocomoke City", zips: "21851" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Salisbury and Eastern Shore departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-ship-line", title: "Eastern Shore & Coastal Coverage", desc: "Serving Wicomico County, Worcester County, and coastal resort towns" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Annapolis, MD", route: "/cities/annapolis" },
    { name: "Emergency passport help in Ocean City, MD", route: "/cities/ocean-city" },
    { name: "Urgent passport services in Baltimore, MD", route: "/cities/baltimore" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Salisbury, Maryland remotely via secure registered courier. We do not have a walk-in office in Salisbury — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Eastern Shore travelers without the long drive across the Bay Bridge to downtown DC.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, MD 20814",
  fpcOfficeDistance: "Serving Salisbury, Fruitland, Delmar, Ocean City, and all of the Eastern Shore",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Eastern Shore of Maryland. From the historic downtown of Salisbury to the beach resort towns of Ocean City and Berlin, from the Salisbury University campus to the agricultural communities of Wicomico County — we serve all of the Delmarva Peninsula.",
  nearbyCitiesIntro: "We serve Salisbury and nearby communities including Fruitland, Delmar, Hebron, Parsonsburg, Pittsville, Willards, Ocean City, Berlin, Ocean Pines, Snow Hill, and all of Wicomico and Worcester counties. We also serve travelers from Sussex County, Delaware including Seaford and Laurel.",
  howItWorksIntro: "Most Salisbury travelers complete everything online and ship documents overnight. No need to drive 2.5–3 hours across the Chesapeake Bay Bridge to downtown DC.",
  mistakesIntro: "Eastern Shore travelers face unique challenges due to geographic isolation from major passport agencies. Here are the most common mistakes we see from Salisbury and coastal Maryland travelers.",
  testimonialsIntro: "Salisbury travelers — from university students to coastal resort workers to agricultural families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Salisbury, MD? Here are the most common ones we hear from Eastern Shore travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 2.5–3 hours to downtown DC", "Full day commitment — practically impossible for Eastern Shore residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for Eastern Shore and coastal travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Salisbury travelers with immediate departure needs — as fast as 24 hours. Perfect for coastal resort travel, university study abroad, and last-minute family emergencies.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Coastal and university travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Salisbury adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Salisbury address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Salisbury residents and families — including university students and coastal resort workers.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Salisbury residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Salisbury families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Salisbury residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Salisbury MD", description: "Urgent passport processing for Salisbury Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Salisbury MD", description: "Fast passport renewal for Salisbury Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Salisbury MD", description: "New passport application services for Salisbury Maryland residents applying for their first passport." },
    { name: "Child Passport Salisbury MD", description: "Minor passport services for Salisbury Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Emily R.",
      location: "Salisbury, MD",
      rating: 5,
      text: "Study abroad program to Spain starting in 8 days and my passport was expired. Fast Passport Center saved my semester. They reviewed everything, caught a form error, and had my passport in 4 days. Perfect for Salisbury University students.",
      service: "Emergency Passport",
    },
    {
      name: "Mark T.",
      location: "Ocean City, MD",
      rating: 5,
      text: "Family cruise to the Bahamas with 10 days notice. Four passports processed in under a week. The agent coordinated everything — we just shipped from the UPS Store on N Salisbury Blvd.",
      service: "Family Passport Bundle",
    },
    {
      name: "Jennifer K.",
      location: "Fruitland, MD",
      rating: 5,
      text: "Business trip to Toronto with a week's notice. Living on the Eastern Shore, I thought I'd have to drive across the Bay Bridge to DC. Fast Passport Center shipped everything overnight and my passport was back in 3 days.",
      service: "Emergency Passport",
    },
    {
      name: "Robert L.",
      location: "Delmar, MD",
      rating: 5,
      text: "Renewed my passport for a European tour. The process was so simple — filled everything out online, shipped from Salisbury, and had it back in under 2 weeks. Great for Eastern Shore residents.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "salisbury-1",
      name: "Salisbury Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "805 N Salisbury Blvd",
      city: "Salisbury",
      state: "MD",
      zip: "21801",
      phone: "(410) 749-2134",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Salisbury, near the Salisbury University area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Salisbury acceptance facility for Wicomico County. Appointments required — book 1–2 weeks in advance. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "salisbury-2",
      name: "Wicomico County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "101 N Division St",
      city: "Salisbury",
      state: "MD",
      zip: "21801",
      phone: "(410) 548-4801",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Salisbury, near the courthouse complex",
      website: "https://www.wicomico.org/",
      websiteLabel: "Wicomico County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office. Convenient for downtown Salisbury residents and workers.",
      icon: "ri-government-line",
    },
    {
      id: "salisbury-3",
      name: "Fruitland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 E Main St",
      city: "Fruitland",
      state: "MD",
      zip: "21826",
      phone: "(410) 742-5273",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fruitland, approximately 3 miles west of downtown Salisbury",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for western Wicomico County and Fruitland residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "salisbury-4",
      name: "Ocean City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12741 Ocean Gateway",
      city: "Ocean City",
      state: "MD",
      zip: "21842",
      phone: "(410) 289-3531",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ocean City, approximately 30 miles east of Salisbury",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for coastal resort town residents and Worcester County travelers. Busy during summer season — book early.",
      icon: "ri-mail-line",
    },
    {
      id: "salisbury-5",
      name: "Berlin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Bay St",
      city: "Berlin",
      state: "MD",
      zip: "21811",
      phone: "(410) 641-0041",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Berlin, approximately 25 miles east of Salisbury",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for Ocean Pines and northern Worcester County residents. Historic town center location.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2.5–3 hour drive across Bay Bridge to DC", fpc: "No — ship from Salisbury" },
    { feature: "Coastal Travel Support", agency: "No flexibility for resort town needs", fpc: "Yes — we handle Eastern Shore cases" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Eastern Shore residents face the longest drive to the DC passport agency of anyone in Maryland. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Salisbury and the Eastern Shore sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Salisbury and Wicomico County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Salisbury Post Office appointments fill up fast, especially during summer travel season and before Ocean City beach season. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Eastern Shore residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Salisbury, Fruitland, or Ocean City." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near downtown Salisbury or along US-13." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Salisbury address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Salisbury, MD?", a: "Fast Passport Center offers emergency passport processing in Salisbury, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency — without you needing to make the 2.5–3 hour drive across the Chesapeake Bay Bridge." },
    { q: "Does Salisbury have its own passport agency?", a: "No — neither Salisbury nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 2.5–3 hours from Salisbury via US-50 W and I-495 S. Fast Passport Center's courier service means Eastern Shore residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Ocean City or Berlin?", a: "Absolutely. Fast Passport Center serves all of the Eastern Shore including Ocean City, Berlin, Ocean Pines, Snow Hill, Pocomoke City, and all of Worcester and Wicomico counties. We also serve travelers from Sussex County, Delaware. Our overnight shipping means coastal resort residents get the same fast service as city dwellers." },
    { q: "How much does an expedited passport cost in Salisbury, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Salisbury travelers use for international flights?", a: "Most Salisbury residents fly internationally through Salisbury-Ocean City Wicomico Regional Airport (SBY), approximately 5 minutes southwest of downtown. SBY offers connections to major hubs. Baltimore-Washington International (BWI) is approximately 2 hours west via US-50. Philadelphia International (PHL) is approximately 2.5 hours north. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Salisbury?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Salisbury, Fruitland, Ocean City, and all of the Eastern Shore. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Salisbury?", a: "The Salisbury Post Office at 805 N Salisbury Blvd is the primary acceptance facility for Wicomico County. The Wicomico County Clerk's Office at 101 N Division St offers extended hours. The Fruitland Post Office at 101 E Main St serves western Salisbury. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Eastern Shore residents should plan ahead, especially for coastal resort travel and university study abroad programs." },
  ],
  photoLocations: [
    { name: "Walgreens — Salisbury", address: "101 E Naylor Mill Rd, Salisbury, MD 21804", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Salisbury", address: "101 E Carroll St, Salisbury, MD 21801", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Salisbury", address: "1405 S Salisbury Blvd, Salisbury, MD 21801", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Salisbury", address: "101 E Naylor Mill Rd, Salisbury, MD 21804", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "MVA — Salisbury", address: "2424 N Salisbury Blvd, Salisbury, MD 21801", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Full-service MVA for Wicomico County and the Eastern Shore. REAL ID processing available.", featured: true },
    { name: "MVA — Ocean City", address: "12741 Ocean Gateway, Ocean City, MD 21842", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Seasonal MVA location for Worcester County and coastal residents. Approximately 30 minutes from Salisbury.", featured: false },
  ],
  airports: [
    {
      code: "SBY",
      name: "Salisbury-Ocean City Wicomico Regional",
      distance: "5 minutes from downtown Salisbury",
      address: "5485 Airport Terminal Rd, Salisbury, MD 21804",
      note: "Primary regional airport for Salisbury and Eastern Shore travelers. Connections to major hubs for international flights. American Airlines service.",
      flightUrl: "https://www.flysbyairport.com/",
      flightLabel: "SBY Flight Info",
      featured: true,
    },
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "2 hours from Salisbury via US-50 W",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Major international departure airport for Eastern Shore travelers. Direct flights to London, Cancun, Reykjavik, and the Caribbean. Southwest Airlines hub.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: false,
    },
    {
      code: "PHL",
      name: "Philadelphia International",
      distance: "2.5 hours from Salisbury via US-13 N",
      address: "8000 Essington Ave, Philadelphia, PA 19153",
      note: "Alternative for long-haul international flights to Europe and Asia. American Airlines hub.",
      flightUrl: "https://www.phl.org/",
      flightLabel: "PHL Flight Info",
      featured: false,
    },
  ],
};